import React from "react";
import { Row, Col, Select, Form, Button } from "antd";
import {
  // edukimiQytetar,
  keshillat,
  komisionetParlFilter,
  nenKomisionet,
  organeKuvendi,
  sekretariate,
} from "helpers/strukturaDefiners";
import { useTranslation } from "react-i18next";
import { getTranslatedField } from "helpers";

const { Option } = Select;

export const Filters = ({ form, handleRecordsFilter, clearFilters, t }) => {
  const allStructures = [
    ...komisionetParlFilter,
    ...sekretariate,
    ...organeKuvendi,
    ...keshillat,
    ...nenKomisionet,
    // ...edukimiQytetar,
  ];
  const { i18n } = useTranslation();
  return (
    <Form form={form}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={6} sm={12} className="strukture-filter">
          <Form.Item name="struktureId">
            <Select
              placeholder={t("procesVerbalPage.filters.structure")}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {allStructures.map((str) => (
                <Option key={str.id} value={str.id}>
                  {getTranslatedField(str, i18n, "emer", "emerEn")}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleRecordsFilter}
          >
            {t("navigation.searchPlaceholder")}
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={clearFilters}>
            {t("allNewsPage.filters.cleaFilters")}
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
};
export default Filters;
